import { apiServiceInstance } from '../helpers/utils';
import {
  ApiResponse,
  PaginationResponseBase,
  PositionBaseResponse,
} from './../interfaces/ApiResponses';

export type ChucVuListParams = {
  /** Search `ten_chuc_vu` / `ten_viet_tat` */
  q?: string;
  /** Admin tables — Laravel paginator. Omit for select dropdowns (full array). */
  paginate?: boolean;
  page?: number;
};

function normalizeChucVuList(
  data: PositionBaseResponse[] | PaginationResponseBase<PositionBaseResponse>
): PositionBaseResponse[] {
  if (Array.isArray(data)) {
    return data;
  }
  return data?.data || [];
}

export default class ChucVuService {
  /**
   * Default API shape is a full array (for selects).
   * Pass `paginate: true` for admin table paging.
   */
  static list(params: ChucVuListParams = {}): Promise<{
    data: ApiResponse<
      PositionBaseResponse[] | PaginationResponseBase<PositionBaseResponse>
    >;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      '/api/v1/chuc-vu/danh-sach',
      {
        params: {
          ...(params.q ? { q: params.q } : {}),
          ...(params.paginate ? { paginate: 1 } : {}),
          ...(params.page ? { page: params.page } : {}),
        },
      }
    );
  }

  /** Full catalog for `<el-select>` / dropdowns (no paginate). */
  static async listForSelect(q?: string): Promise<PositionBaseResponse[]> {
    const {
      data: { data },
    } = await ChucVuService.list(q ? { q } : {});
    return normalizeChucVuList(data);
  }

  /** Null-safe: missing / orphan / id<=0 returns `data: null` (HTTP 200). */
  static get(id: number): Promise<{
    data: ApiResponse<PositionBaseResponse | null>;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      `/api/v1/chuc-vu/chi-tiet/${id}`
    );
  }

  static create(
    name: string,
    shortName: string
  ): Promise<{
    data: ApiResponse<PositionBaseResponse>;
  }> {
    apiServiceInstance().vueInstance.axios.defaults.headers.common[
      'Content-Type'
    ] = 'multipart/form-data';
    const bodyFormData = new FormData();
    bodyFormData.append('chucVuInstance[ten_chuc_vu]', name);
    bodyFormData.append('chucVuInstance[ten_viet_tat]', shortName);
    return apiServiceInstance().vueInstance.axios.post(
      '/api/v1/chuc-vu/tao-moi',
      bodyFormData
    );
  }

  static update(
    id: number,
    name: string,
    shortName: string
  ): Promise<{
    data: ApiResponse<PositionBaseResponse>;
  }> {
    apiServiceInstance().vueInstance.axios.defaults.headers.common[
      'Content-Type'
    ] = 'multipart/form-data';
    const bodyFormData = new FormData();
    bodyFormData.append('chucVuInstance[ten_chuc_vu]', name);
    bodyFormData.append('chucVuInstance[ten_viet_tat]', shortName);
    return apiServiceInstance().vueInstance.axios.post(
      `/api/v1/chuc-vu/cap-nhat/${id}`,
      bodyFormData
    );
  }

  static delete(id: number) {
    return apiServiceInstance().vueInstance.axios.post(
      `/api/v1/chuc-vu/xoa/${id}`
    );
  }
}
